import { render, staticRenderFns } from "./FamiliesFiltersModal.vue?vue&type=template&id=6ab6ff4d&"
import script from "./FamiliesFiltersModal.vue?vue&type=script&lang=js&"
export * from "./FamiliesFiltersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports